// ============================================================
// Badge.js
// Small pill component. Used for status, role, count chips.
// Variants are colour-only; semantics are caller's concern.
// ============================================================

import React from 'react';
import './Badge.css';

const VARIANT_CLASS = {
  neutral: 'badge--neutral',
  info:    'badge--info',
  success: 'badge--success',
  warning: 'badge--warning',
  danger:  'badge--danger',
  teal:    'badge--teal',
  blue:    'badge--blue',
  purple:  'badge--purple',
  orange:  'badge--orange',
};

export default function Badge({ variant = 'neutral', children, className = '' }) {
  const cls = `badge ${VARIANT_CLASS[variant] || VARIANT_CLASS.neutral} ${className}`.trim();
  return <span className={cls}>{children}</span>;
}
